




























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ExclamationIcon from "./icons/ExclamationIcon.vue";
import LockIcon from "./icons/LockIcon.vue";
import PencilIcon from "./icons/PencilIcon.vue";
import TrashCanIcon from "./icons/TrashCanIcon.vue";
import UpdateDottedIcon from "./icons/UpdateDottedIcon.vue";
import UpdateIcon from "./icons/UpdateIcon.vue";
import { Route } from "vue-router";
@Component({
    components: {
        ExclamationIcon,
        LockIcon,
        PencilIcon,
        TrashCanIcon,
        UpdateDottedIcon,
        UpdateIcon,
    },
})
export default class ppdwIconTextBtn extends Vue {
    @Prop({ default: null }) icon: string;
    @Prop({ default: 24 }) iconSize: number;
    @Prop({ default: "primary" }) color: string;
    @Prop({ default: "" }) text: string;
    @Prop({ default: false }) isMenuItem: boolean;
    @Prop({ default: () => {} }) action: Route | Function;
    @Prop(Boolean) disabled: boolean;

    get isCustom() {
        return this.icon.startsWith("icon-");
    }

    _action() {
        if (this.disabled) return;
        if (typeof this.action === "object" && this.action.name) {
            this.$router.push(this.action);
        } else if (typeof this.action === "function") this.action();
    }
}
